import { client } from "@/api/client";
import interceptors from "@/api/interceptors";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataProduct(params) {
	return client.get("api/ecommerce/product/data", {
		params: params,
	});
}

function exportProduct(params) {
	return client.get("api/ecommerce/product/export", {
		params: params,
	});
}
function getDataProductCategory(params) {
	return client.get("api/ecommerce/product/data-category", {
		params: params,
	});
}


export default {
	getDataProduct,
	exportProduct,
	getDataProductCategory,
}